import { Navigate, Outlet } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { SSORoute } from "@/components/SSORoute";
import { RedirectIfAuth } from "@/components/RedirectIfAuth";
import { PlaceholderPage } from "@/pages/PlaceholderPage";
import { DemographicsPage } from "@/pages/complaint/DemographicsPage";
import { FinancialResponsibilityPage } from "@/pages/complaint/FinancialResponsibilityPage";
import { FinancialResponsibilityInsurancePage } from "@/pages/complaint/FinancialResponsibilityInsurancePage";
import { WorkersCompensationPage } from "@/pages/complaint/WorkersCompensationPage";
import { AutoInsurancePage } from "@/pages/complaint/AutoInsurancePage";
import { HealthInsurancePage } from "@/pages/complaint/HealthInsurancePage";
import { PrimaryComplaintPage } from "@/pages/complaint/PrimaryComplaintPage";
import { ComplaintHistoryPage } from "@/pages/complaint/ComplaintHistoryPage";
import { ComplaintFactorsPage } from "@/pages/complaint/ComplaintFactorsPage";
import { OutcomeAssessmentPage } from "@/pages/complaint/OutcomeAssessmentPage";
import { ComplaintSummaryPage } from "@/pages/complaint/ComplaintSummaryPage";
import { HeadacheHistoryPage } from "@/pages/complaint/HeadacheHistoryPage";
import { DizzinessPage } from "@/pages/complaint/DizzinessPage";
import { WellnessPage } from "@/pages/complaint/WellnessPage";
import { HealthHistory1Page } from "@/pages/complaint/HealthHistory1Page";
import { HealthHistory2Page } from "@/pages/complaint/HealthHistory2Page";
import { HealthHistory3Page } from "@/pages/complaint/HealthHistory3Page";
import { FamilyHistoryPage } from "@/pages/complaint/FamilyHistoryPage";
import { PediatricHistoryPage } from "@/pages/complaint/PediatricHistoryPage";
import { PortalConfigPage } from "@/pages/complaint/PortalConfigPage";
import { CommPrefsWizardPage } from "@/pages/complaint/CommPrefsWizardPage";
import { TaskCompletePage } from "@/pages/complaint/TaskCompletePage";
import { InsuranceCompletePage } from "@/pages/complaint/InsuranceCompletePage";
import { DashboardPage } from "@/pages/DashboardPage";
import { MessagesPage } from "@/pages/MessagesPage";
import { AppointmentsPage } from "@/pages/AppointmentsPage";
import { BillingPage } from "@/pages/BillingPage";
import { DocumentsPage } from "@/pages/DocumentsPage";
import { StatementPage } from "@/pages/StatementPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { TasksPage } from "@/pages/TasksPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { LoginPage } from "@/pages/account/LoginPage";
import { RequestPinPage } from "@/pages/account/RequestPinPage";
import { ForgotPasswordPage } from "@/pages/account/ForgotPasswordPage";
import { AccountLayout } from "@/layouts/AccountLayout";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import { TaskLayout } from "@/layouts/TaskLayout";
import { ComplaintLayout } from "@/layouts/ComplaintLayout";
import { FormHandler } from "@/components/forms/FormHandler";
import { FvTaskPage } from "@/pages/task/FvTaskPage";
import { TaskLinkPage } from "@/pages/task/TaskLinkPage";

export const routes = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "menu/messages", element: <MessagesPage /> },
      { path: "menu/statement", element: <StatementPage /> },
      { path: "menu/viewpdf", element: <PlaceholderPage title="View PDF" /> },
      { path: "menu/appointments", element: <AppointmentsPage /> },
      { path: "menu/billing", element: <BillingPage /> },
      { path: "menu/documents", element: <DocumentsPage /> },
      { path: "menu/profile", element: <ProfilePage /> },
      { path: "menu/tasks", element: <TasksPage /> },
      { path: "form-handler", element: <FormHandler /> },
    ],
  },
  {
    path: "/contact",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/complaint",
    element: (
      <SSORoute>
        <ComplaintLayout />
      </SSORoute>
    ),
    children: [
      { index: true, element: <Navigate to="/complaint/demographics" replace /> },
      { path: "demographics", element: <DemographicsPage /> },
      { path: "communication-preferences", element: <CommPrefsWizardPage /> },
      { path: "financial-responsibility", element: <FinancialResponsibilityPage /> },
      { path: "financial-responsibility-insurance", element: <FinancialResponsibilityInsurancePage /> },
      { path: "pediatric-history", element: <PediatricHistoryPage /> },
      { path: "health-insurance", element: <HealthInsurancePage /> },
      { path: "auto-insurance", element: <AutoInsurancePage /> },
      { path: "workers-compensation", element: <WorkersCompensationPage /> },
      { path: "primary-complaint", element: <PrimaryComplaintPage /> },
      { path: "complaint-history", element: <ComplaintHistoryPage /> },
      { path: "complaint-factors", element: <ComplaintFactorsPage /> },
      { path: "secondary-complaint", element: <PlaceholderPage title="Secondary Complaint" /> },
      { path: "complaint-summary", element: <ComplaintSummaryPage /> },
      { path: "headache-history", element: <HeadacheHistoryPage /> },
      { path: "outcome-assesment", element: <OutcomeAssessmentPage /> },
      { path: "outcome-assesment-new", element: <OutcomeAssessmentPage /> },
      { path: "outcome-assesment2", element: <OutcomeAssessmentPage /> },
      { path: "dizziness", element: <DizzinessPage /> },
      { path: "wellness", element: <WellnessPage /> },
      { path: "health-history", element: <HealthHistory1Page /> },
      { path: "health-history-2", element: <HealthHistory2Page /> },
      { path: "health-history-3", element: <HealthHistory3Page /> },
      { path: "family-history", element: <FamilyHistoryPage /> },
      { path: "portal-config", element: <PortalConfigPage key="portal-config" /> },
      { path: "general-history", element: <PortalConfigPage key="general-history" /> },
      { path: "task-complete", element: <TaskCompletePage /> },
      { path: "insurance-complete", element: <InsuranceCompletePage /> },
    ],
  },
  {
    path: "/statement/payment/new-card",
    element: (
      <ProtectedRoute>
        <PlaceholderPage title="Fortis Payment" />
      </ProtectedRoute>
    ),
  },
  {
    path: "/account",
    element: <AccountLayout />,
    children: [
      { index: true, element: <Navigate to="/account/login" replace /> },
      {
        path: "login",
        element: (
          <RedirectIfAuth>
            <LoginPage />
          </RedirectIfAuth>
        ),
      },
      { path: "requestpin", element: <RequestPinPage /> },
      { path: "forgotpassword", element: <ForgotPasswordPage /> },
    ],
  },
  {
    path: "/task",
    element: <Outlet />,
    children: [
      { index: true, element: <TaskLinkPage /> },
      {
        path: "fv",
        element: (
          <ProtectedRoute>
            <TaskLayout />
          </ProtectedRoute>
        ),
        children: [{ index: true, element: <FvTaskPage /> }],
      },
    ],
  },
  {
    path: "/sso-handler",
    element: <PlaceholderPage title="SSO Handler" />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];
